import { CmsDataService } from '@omnia/ui/src/lib/services/cms.data.service'
import type { InitialData } from './models/initialData'

export class CineColombiaCmsDataService extends CmsDataService<InitialData> {}

export const cmsDataService = new CineColombiaCmsDataService()
